import React from 'react';
import './Footer.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        
        {/* About Section */}
        <div className="footer-section about">
          <h3>Sezonski Poslovi Star</h3>
          <p>© 2025 Sezonski Poslovi Star – Povezujemo poslodavce i radnike kroz sezonske i stalne poslove. Vaš pouzdan partner za zapošljavanje.</p>
        </div>

        {/* Quick Links */}
        <div className="footer-section links">
          <h3>Brzi Linkovi</h3>
          <ul>
            <li><a href="/">Početna</a></li>
            <li><a href="/jobs-page">Svi Poslovi</a></li>
            <li><a href="/fastApplication">Brza Prijava</a></li>
            <li><a href="/create-cv">Napravi CV</a></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-section contact">
          <h3>Kontakt</h3>
          <p>Email: sezonskiposlovistar@gmail.com</p>
          <p>Telefon: +382 63 454 683</p>
          {/* <p>Adresa: </p> */}
        </div>

        {/* Social Media */}
        <div className="footer-section social">
          <h3>Pratite nas</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/sezonskiposlovi_star/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            <a href="https://www.facebook.com/p/SezonskiPoslovi-Star-100077441763898/" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
            <a href="https://invite.viber.com/?g2=AQAGr29t83Ka1E8Cmd%2FMrZm126TOGPcAzzz%2BVEZSOTLQtw3E51CP5UWEKZ6cwrX4&lang=en" title="Viber"><i className="fab fa-viber"></i></a>
            <a href="https://www.linkedin.com/in/sezonski-poslovi-star-7811ba183/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in"></i></a>
            <a href="https://t.me/sezonski_poslovi_star" target="_blank" rel="noopener noreferrer"><i className="fab fa-telegram-plane"></i></a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Sezonski Poslovi Star. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
